export default "__VITE_ASSET__hVuY90_X__"